import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    situacionFinanciera: [],
  },

  getters: {
    getSituacionFinanciera: (state) => state.situacionFinanciera,
  },

  mutations: {
    SET_SITUACION_FINANCIERA(state, situacionFinanciera) {
      state.situacionFinanciera = situacionFinanciera;
    },
  },

  actions: {
    async fetchSituacionFinanciera({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/situacionesfinancieras`)
        .then((response) => {
          commit('SET_SITUACION_FINANCIERA', response.data.data);
        });
    },

    async saveSituacionFinanciera(_, situacionFinanciera) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${situacionFinanciera.fk_idExpediente}/situacionesfinancieras`, situacionFinanciera);
    },

    async updateSituacionFinanciera(_, situacionFinanciera) {
      await axios
        .put(
          `PoliciaCuadrantes/C3/personal/${situacionFinanciera.fk_idPersonal}/situacionFinanciera/${situacionFinanciera.fk_idBoletasArresto}`,
          situacionFinanciera,
        );
    },
  },
};
